import i18n from "@/i18n";
import PageForm from "@/assets/ts/interfaces/form/pageForm";
import Info from "@/assets/ts/interfaces/form/info";
const order = ['basic', 'secondary', 'higher'];
import { Types } from "@/assets/ts/enums/form/types";
import handle_submit from "../callbacks/handle_submit";

function getOrg() {
  const organization: PageForm =
  {
    title: i18n.global.t('proposal.form.side_panel.title'),
    image: require('@/assets/img/windmill.png'),
    imageCircle: true,
    name: i18n.global.t('proposal.form.side_panel.organization'),
    form: [
      {
        title: '',
        titleMobile: i18n.global.t('proposal.form.organization.title_mobile'),
        fields: [
          {
            title: i18n.global.t('proposal.form.organization.title'),
            subtitle: i18n.global.t('proposal.form.organization.subtitle'),
            key: "nipc",
            value: "",
            rules: "required|maxLength:20|alphaNumeric",
            type: Types.STRING,
            label: i18n.global.t('proposal.form.organization.form.fiscal')
          },
          {
            key: "promoter_name",
            value: "",
            rules: "required",
            type: Types.STRING,
            label: i18n.global.t('proposal.form.organization.form.name')
          },
          {
            key: "promoter_email",
            value: "",
            rules: "required|email",
            type: Types.EMAIL,
            label: i18n.global.t('proposal.form.organization.form.email')
          }
        ],
        next: true,
        nextText: i18n.global.t('proposal.form.organization.btn'),
        back: true,
        nextCallback: handle_submit,
      }
    ],
    sub_steps: []
  }
  return organization;
}


export default getOrg
